import {Link} from "@tanstack/react-router";
import {formatLabel} from "@/utils/utils.ts";
import Breadcrumbs from "@/components/Breadcrumbs";
import PolicyBody from "@/components/PolicyBody.tsx";
import type {PolicyPageData} from "@/types/types.ts"

interface PageProps {
    contentData: PolicyPageData
}

/**
 * Policy Detail Page Component
 * Displays if data is successfully returned from Confluence for a page
 * Called by routes/policy/$pageId.tsx.
 */

export default function Page({contentData}: PageProps) {

    return (
        <>
            <div className="Hero Hero--minimal Hero--policy-library-detail">
                <div className="Hero__content">
                     <Breadcrumbs pageTitle={contentData?.title} />
                    {contentData?.title && <h1 className="Hero__title" data-animate="true">{contentData.title}</h1>}
                </div>
            </div>
            <PolicyBody html={contentData?.body?.view?.value} />
            {!!contentData?.labels?.results?.length && (
                <div className="policy-detail-categories">
                    <p><strong>Categories:</strong></p>
                    <ul>
                        {contentData.labels.results.map((label) => (
                            <li key={label.id}><Link to="/"
                                                     search={{cat: [label.name]}}>{formatLabel(label.name)}</Link></li>
                        ))}
                    </ul>
                </div>)}
        </>
    )
}